export default __webpack_public_path__ + "static/media/slide_06.6971a9ff.png";